// Touch.js
var Touch = pc.createScript("touch");

Touch.attributes.add("OnTouch", { type: "boolean"});
Touch.attributes.add("Cover", {type: "entity"});
Touch.attributes.add("posX", { type: "number"});
Touch.attributes.add("posY", { type: "number"});
Touch.attributes.add("dist", { type: "vec3"});

Touch.prototype.initialize = function() {
    
    Touch.instance = this;
    this.select = null;
    this.time_passed = 0;
    this.power_multiplier = 0.3;
   
    this.ray = new pc.Ray();
    this.pos = new pc.Vec3();
    this.cameraEntity = this.entity;
    
    this.leftClickStatus = false;

    this.app.mouse.on(pc.EVENT_MOUSEMOVE, this.onTouchMove, this);
    this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onSelect, this);
    this.app.mouse.on(pc.EVENT_MOUSEUP, this.onTouchEnd, this);

    if (this.app.touch) {
        this.app.touch.on(pc.EVENT_TOUCHSTART, this.onSelect, this);
        this.app.touch.on(pc.EVENT_TOUCHEND, this.onTouchEnd, this);
        this.app.touch.on(pc.EVENT_TOUCHMOVE, this.onTouchMove, this);
    }

    this.app.on('gameManager:updatestatus',this.Status,this);
    this.entity.on("destroy", this.OnDestroy,this);
    
    this.velocity = new pc.Vec3(0,0,0);
    this.direction = new pc.Vec3();
    this.distance = 0;
    this.power = 0;
    
    this.StartWorldPos = new pc.Vec3(0,0,0);
    this.EndWorldPos = new pc.Vec3(0,0,0);
    
    this.touchStarted = false;
    this.touchEnded = false;
    
    this.startPos = new pc.Vec2(0,0);
    this.EndPos = new pc.Vec2(0,0);
    
    this.time = 0;
    this.duration = 0;
    
    this.startX = 0;
    this.startY = 0;
    
    this.endX = 0;
    this.endY = 0;
    this.canThrow = false;
    
    this.canvas = document.getElementById("application-canvas");
    this.canvas.addEventListener("mouseleave", function (event) {
        if (Touch.instance.leftClickStatus) {
            //console.log('mouse is out');
            Touch.instance.onTouchEnd();
        }
    }, false);

    this.disableTouchController=true;
};

Touch.prototype.doRayCast =function(ex,ey) {

    this.startPos.set(ex, ey);
    this.startX = ex;
    this.startY = ey;
    this.power = 0;

var start = this.entity.camera.screenToWorld(ex, ey, this.entity.camera.nearClip);
        var end = this.entity.camera.screenToWorld(ex, ey, this.entity.camera.farClip);
        
        this.app.systems.rigidbody.raycastFirst(start, end,function(result){

            if (result.entity.name == "drop_area") {
                
                untouchableSelect = this.app.root.findByTag("untouchable")[0];
                Touch.instance.select = this.app.root.findByTag("dropped")[0];
                if ((untouchableSelect != undefined) || (Touch.instance.select === undefined)) return;
                Touch.instance.select.tween(Touch.instance.select.getLocalScale()).to(new pc.Vec3(1.3, 1.3, 1.3), 0.2, pc.CubicInOut).start();
                Touch.instance.select.rigidbody.type = pc.BODYTYPE_KINEMATIC;
                Touch.OnTouch = true;
                this.dist = Touch.instance.entity.camera.worldToScreen(result.entity.getPosition());
                this.posX = ex - this.dist.x;
                this.posY = ey - this.dist.y;
            }
            else if (result.entity.tags.has('Select')) {
                Touch.instance.select = result.entity;
                
                Touch.instance.select.tween(Touch.instance.select.getLocalScale()).to(new pc.Vec3(1.3, 1.3, 1.3), 0.2, pc.CubicInOut).start();
                Touch.instance.select.rigidbody.type = pc.BODYTYPE_KINEMATIC;
                
                Touch.OnTouch = true;
                this.dist = Touch.instance.entity.camera.worldToScreen(result.entity.getPosition());
                this.posX = ex - this.dist.x;
                this.posY = (ey - this.dist.y);

                if (PlayerManager.instance.levelData.levelName === 'Donut Shop') {
                    if (Tutorial.instance.isCheckMoveTutorialStatus == false) {
                        Tutorial.instance.moveObjectTutorialOnOff(false);
                        Tutorial.instance.isCheckMoveTutorialStatus = true;
                    }
                    if (Tutorial.instance.isCheckFactorTutorialStatus == true) {
                        Tutorial.instance.moveFactorTutorialOnOff(false);
                        isCheckFactorTutorialStatus = false;
                    }
                }
            }
        });
};

Touch.prototype.onSelect = function (e) {

    if (!this.disableTouchController) {
        this.time = 0;
        this.duration = 0 ;
        this.touchStarted = true;
        this.touchEnded = false;

        if (this.touchStarted === true) {
            this.startCounter();
        }

        if (this.app.touch) {
            this.doRayCast(e.touches[0].x, e.touches[0].y);
            e.event.preventDefault();
        }
        else {
            if (e.button === pc.MOUSEBUTTON_LEFT) {
                this.leftClickStatus = true;
                this.doRayCast(e.x, e.y);
            }
        }
    }
};

Touch.prototype.onTouchMove = function (e) {
    
    if (this.app.touch) {
        e.x = e.touches[0].x;
        e.y = e.touches[0].y;
        e.event.preventDefault();
    }

    if (!this.disableTouchController) {
        if (Touch.OnTouch === true) {
            this.EndPos.set(e.x, e.y);
            this.canThrow = true;
            this.endX = e.x;
            this.endY = e.y;

            var curPos = new pc.Vec3(e.x - this.posX, e.y - this.posY, this.dist.z);
            var worldPos = this.entity.camera.screenToWorld(curPos.x, curPos.y, 13, worldPos);
            this.select.rigidbody.teleport(worldPos.x, worldPos.y+0.5, worldPos.z);
        }
    }
};


Touch.prototype.onTouchEnd = function (event) {

    //event.event.preventDefault();
    this.touchStarted = false;
    this.touchEnded = true;
    // this.cameraEntity.camera.screenToWorld(this.startX, this.startY, 0.1, this.StartWorldPos);
    // this.cameraEntity.camera.screenToWorld(this.endX, this.endY, 0.1, this.EndWorldPos);
    
    if (!this.disableTouchController) {

        if (Touch.OnTouch == true) {
            this.leftClickStatus = false;
            this.select.tween(this.select.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.2, pc.CubicInOut).start();
            Touch.OnTouch = false;
            this.select.rigidbody.enabled = true;
            this.select.rigidbody.type = pc.BODYTYPE_DYNAMIC;

            this.select.tags.remove("dropped");
            this.select.tags.remove("untouchable");
            if (this.time_passed > 0) {
                this.time = this.time_passed;
            } else {
                this.time = Math.random() * (0.5 - 0.3) + 0.3;
            }
            this.stopCounter();
            if (this.touchEnded) {
                if (this.time_passed <= 10) {
                    this.power_multiplier = 0.22;
                } else if (this.time_passed > 10 && this.time_passed <= 20) {
                    this.power_multiplier = 0.18;
                } else if (this.time_passed > 20) {
                    this.power_multiplier = 0.1;
                } else {
                    this.power_multiplier = 0.1;
                }

                this.direction.sub2(this.EndWorldPos, this.StartWorldPos);
                this.distance = this.direction.length();

                this.power = this.distance / (this.time * this.power_multiplier);

                var StartEndDifferenceX = this.EndWorldPos.x - this.StartWorldPos.x;
                var StartEndDifferenceY = this.EndWorldPos.y - this.StartWorldPos.y;
                var StartEndDifferenceZ = this.EndWorldPos.z - this.StartWorldPos.z;

                x = this.power * 10 * 2 * (StartEndDifferenceX * 100);
                y = this.power * 10 * 2 * (StartEndDifferenceY * 100);
                z = this.power * 10 * 2 * (StartEndDifferenceZ * 100);

                this.select.rigidbody.applyImpulse(x, y, z);
            }
            
            var distance = this.distanceBetween(this.Cover, this.select);

            if (distance < 2.5) {
                this.app.fire('covermanager:entity', this.select);
            }
            this.select = null;
        }
    }
};

Touch.prototype.Status = function (stat) {

    if (stat === gamestatus.Lose || stat === gamestatus.Quit || stat === gamestatus.Win) {
        this.disableTouchController = true;
    }
    else if (stat === gamestatus.Play || stat === gamestatus.OfferPlay || stat === gamestatus.Resume) {
        if (!GameManager.instance.isGamePaused) {
            if (PlayerManager.instance.levelData.levelName == "Donut Shop") {
                this.disableTouchController = false;
            }
            else {
                if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
                    if (PlayerManager.instance.userData.jokerTutorial == true) {
                        this.disableTouchController = false;
                    }
                }
                else {
                    this.disableTouchController = false;
                    // if (PlayerManager.instance.userData.shakeTutorial == true) {
                    //     this.disableTouchController = false;
                    // }
                }
            }
        }
    }
};

Touch.prototype.Pause = function() {
    this.disableTouchController=true;
};

Touch.prototype.Continue = function () {

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        if (PlayerManager.instance.userData.jokerTutorial == true) {
            this.disableTouchController = false;
        }
    }
    else {
        this.disableTouchController = false;
        // if (PlayerManager.instance.userData.shakeTutorial == true) {
        //     this.disableTouchController = false;
        // }
    }
};

Touch.prototype.distanceBetween = function (entityA, entityB) {
    
    var posA = entityA.getPosition();
    var posB = entityB.getPosition();

    var dx = posB.x - posA.x;
    var dy = posB.y - posA.y;
    var dz = posB.z - posA.z;

    return Math.sqrt(dx * dx + dy * dy + dz * dz);
};

Touch.prototype.startCounter = function () {
   this.time_passed = 0;
    function incrementSeconds() {
        Touch.instance.time_passed += 1;
    }
    this.stopInterval = setInterval(incrementSeconds, 300);
};

Touch.prototype.stopCounter = function () {
    clearInterval(this.stopInterval);
};

Touch.prototype.OnDestroy = function(){

    this.app.mouse.off(pc.EVENT_MOUSEMOVE, this.onTouchMove, this);
    this.app.mouse.off(pc.EVENT_MOUSEDOWN, this.onSelect, this);
    this.app.mouse.off(pc.EVENT_MOUSEUP, this.onTouchEnd, this);

    if (this.app.touch) {
        this.app.touch.off(pc.EVENT_TOUCHSTART, this.onSelect, this);
        this.app.touch.off(pc.EVENT_TOUCHEND, this.onTouchEnd, this);
        this.app.touch.off(pc.EVENT_TOUCHMOVE, this.onTouchMove, this);
    }

    this.entity.off("destroy", this.OnDestroy,this);
};

//document.documentElement.addEventListener('mouseleave', () => console.log('mouseOut'));

